/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionTrainingFlagsModel } from '../../models/vision-training-flags-model';

export interface AdminMemberProfileMemberProfileIdVisionFlagsGet$Params {
  memberProfileId: string;
}

export function adminMemberProfileMemberProfileIdVisionFlagsGet(http: HttpClient, rootUrl: string, params: AdminMemberProfileMemberProfileIdVisionFlagsGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>> {
  const rb = new RequestBuilder(rootUrl, adminMemberProfileMemberProfileIdVisionFlagsGet.PATH, 'get');
  if (params) {
    rb.path('memberProfileId', params.memberProfileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>;
    })
  );
}

adminMemberProfileMemberProfileIdVisionFlagsGet.PATH = '/Admin/MemberProfile/{memberProfileId}/VisionFlags';
